// Gated bloom-ring projection (match-screen design D-match-4, tasks.md 3.2): the
// dashed ring at the viability boundary is a pure, injectable projection over a
// `centre` — no authoritative convergence centre streams from the server (the
// seeded, off-centre point of DESIGN §2 is not on the wire, D-075), so the *live*
// ring is omitted in production and rendered only when a centre is supplied
// (fixtures/tests). The contracting bloom otherwise reads from the live vegetation
// (`patches[].pool`) — unaffected by this gate.

export interface BloomRingGeometry {
  centre: readonly [number, number];
  radius: number;
}

/**
 * Returns the ring's world-space geometry (`centre`, `radius = viabilityRadius`)
 * when `centre` is supplied, or `null` (omitted) when it is not — production has no
 * authoritative centre, so calling this with `centre` undefined is the correct,
 * honest "nothing to draw" result, not a missing feature.
 */
export function bloomRing(
  viabilityRadius: number,
  centre?: readonly [number, number],
): BloomRingGeometry | null {
  if (centre === undefined) {
    return null;
  }
  return { centre, radius: viabilityRadius };
}
